import { useQuery } from "@tanstack/react-query";
import { reactQueryCacheAndRefetchOptions } from "@";
import { getWhatsappCampaign } from "../api.ts";
import { whatsappCampaignKeys } from "./keys.ts";
import type { WhatsappCampaignDetail } from "../../types.ts";

// Query hook for fetching a single WhatsApp campaign
export const useWhatsappCampaignQuery = (id: string | undefined) => {
  return useQuery<WhatsappCampaignDetail>({
    queryKey: whatsappCampaignKeys.detail(id!),
    queryFn: async () => {
      const { data } = await getWhatsappCampaign(id!);
      return data;
    },
    enabled: !!id,
    ...reactQueryCacheAndRefetchOptions,
  });
};
